














































































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import helper from '@/services/helper.ts';
import { mapGetters, mapState } from 'vuex';
import api from '@/services/api';
import Q from 'q';
import { Prop } from 'vue-property-decorator';

@Component<CandidateDetailsModal>({
  computed: {
    ...mapState({}),
  },
})
export default class CandidateDetailsModal extends Vue {
  public candidate: CandidateModel | null = null;

  @Prop() protected readonly name!: string;

  public beforeOpen(event: any) {
    const param = event.params;
    this.candidate = event.params || null;
  }

  private opened() {
    if (!this.candidate) this.$modal.hide(this.name);
  }

  public getLink(link: string) {
    if (!link) return '';
    if (!link.startsWith('http')) link = 'http://' + link;
    return link;
  }
}
